var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('barion-pixel'),_c('default-bar'),_c('default-drawer'),_c('default-view'),_c('default-footer'),(false)?_c('default-settings'):_vm._e(),(_vm.isIdle)?_c('modal-idle'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }